import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
} from "../../helpers/storage";
import { showError, showToast } from "../../constants/toasts";
import { setCredentials } from "../../reducers/authSlice";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import { useAppDispatch } from "../../hooks/store";
import { usePostLogInMutation } from "../../services/auth";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import * as Yup from "yup";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import Loader from "../../constants/Loader";
import { ROLES } from "../../utils/enums";
export const sidebar = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Users", path: "/manage-users" },
  { label: "Reset Password Users", path: "/reset-password-requests" },
  { label: "Family / Shared Account", path: "/manage-shared-accounts" },
  { label: "AI Behavior & Language", path: "/voice-library" },
  { label: "Voice Library", path: "/voice-library" },
  { label: "Multilingual Engine", path: "/multilingual-engine" },
  { label: "Emotional AI & Mood Mapping", path: "/mood-mapping" },
  { label: "Subscription & Plan", path: "/manage-subscriptions" },
  { label: "User Engagement Dashboard", path: "/user-engagement" },
  { label: "Wellness & Lifestyle Trends", path: "/wellness-lifestyle" },
  { label: "Financial Overview", path: "/financial-overview" },
  { label: "Budget Categories", path: "/manage-budget-categories" },
  { label: "Alerts Configuration", path: "/manage-alert-configuration" },
  { label: "Document & OCR Processing", path: "/document-processing" },
  { label: "Hydration & Goal Settings", path: "/hydration" },
  { label: "Reminder Engine", path: "/reminder-engine" },
  { label: "Shopping & Meal AI", path: "/shopping-meals" },
  { label: "Label Recognition Editor", path: "/label-recognition" },
  { label: "Location Intelligence", path: "/location-intelligence" },
  { label: "Language Library", path: "/translation-messaging" },
  { label: "Smart Messaging Templates", path: "/smart-messaging" },
  { label: "Notification Management", path: "/manage-notifications" },
  { label: "Revenue Management", path: "/manage-revenue" },
  { label: "Manage Customer Support", path: "/manage-customer-support" },
  { label: "Manage Sub-Admin", path: "/manage-subadmin" },
  { label: "Manage CMS Pages", path: "/manage-cms" },
  { label: "Settings", path: "/settings" },
];

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loginMutation, { isLoading }] = usePostLogInMutation();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: Yup.object({
      remember: Yup.boolean(),
      email: Yup.string()
        .required("Email is required!")
        .max(50, "Email cannot exceed 50 characters")
        .email("Please enter a valid email address!")
        .test("no-leading-trailing-spaces", "Email cannot start or end with spaces", function(value) {
          if (!value) return true; // Let required validation handle empty values
          return value === value.trim();
        }),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      const fcmToken = getFromStorage(STORAGE_KEYS.fcmToken);
      let body = {
        email: formik.values.email.trim(),
        password: formik.values.password,
        // deviceToken: fcmToken || "123",
        // deviceType: "WEB",
      };

      try {
        // let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
        const response = await loginMutation(body).unwrap();
       

        if (response?.status === 200) {
          // Store token and credentials
          setToStorage(STORAGE_KEYS.token, response?.access || "");
          dispatch(
            setCredentials({
              user: response?.data || null,
              token: response?.access || "",
            })
          );

          // Handle remember me functionality
          if (formik.values.remember) {
            setToStorage(STORAGE_KEYS.credentials, JSON.stringify(body));
          } else {
            removeFromStorage(STORAGE_KEYS.credentials);
          }

          // Show success message
          showToast("Logged In Successfully.");


          // Handle redirect based on user role
          if (response?.data?.role === ROLES.SUB_ADMIN) {
          
            const permissions = response?.data?.accessRole?.permission;
        

            if (permissions && permissions.length > 0) {
              const firstPermissionLabel = permissions.find(
                (item: any) => item.isView === true
              )?.label;

            

              if (firstPermissionLabel) {
                const redirectPath = sidebar.find(
                  (item) => item.label === firstPermissionLabel
                )?.path;

             

                if (redirectPath) {
              
                  navigate(redirectPath);
                } else {
               
                  navigate("/dashboard");
                }
              } else {
              
                navigate("/dashboard");
              }
            } else {
           
              navigate("/dashboard");
            }
          } else {
            // For regular users, redirect to dashboard
          
            navigate("/dashboard");
          }
        }
      } catch (error: any) {
        console.error("Login error:", error);
        showError(error?.data?.message || "");
      }
    },
  });
  useEffect(() => {
    // Check if user is already authenticated
    const token = getFromStorage(STORAGE_KEYS.token);
    if (token) {
      // User is already logged in, redirect to dashboard
      navigate("/dashboard", { replace: true });
      return;
    }

    const data = getFromStorage(STORAGE_KEYS.credentials);
    if (data) {
      const rememberData = JSON.parse(`${data}`);
      formik.setFieldValue("password", rememberData?.password);
      formik.setFieldValue("email", rememberData?.email);
      formik.setFieldValue("remember", true);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [navigate]);
  return (
    <AuthLayout>
      {/* <Loader isLoading={isLoading} /> */}
      <div className="authBox">
        <h2>Login</h2>
        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label>Email Address</label>
            <TextField
              className="text_field"
              placeholder="Enter Email Address"
              hiddenLabel
              fullWidth
              name="email"
              id="email"
              inputProps={{ maxLength: 50 }}
              value={formik.values.email}
              onChange={(val) => {
                const inputValue = val.target.value;
                // Don't allow single space or dot
                if (inputValue === " " || inputValue === ".") {
                  return;
                }
                // Update formik with the input value (trimming will happen on blur and submit)
                formik.handleChange(val);
              }}
              onBlur={(e) => {
                // Trim spaces on blur as well
                const trimmedValue = e.target.value.trim();
                if (trimmedValue !== e.target.value) {
                  formik.setFieldValue("email", trimmedValue);
                }
                formik.handleBlur(e);
              }}
              helperText={
                formik.touched.email && (formik.errors.email as string)
              }
              error={formik.touched.email && Boolean(formik.errors.email)}
            />
          </div>
          <div className="control_group">
            <label>Password</label>
            <TextField
              className="text_field"
              placeholder="Enter Password"
              fullWidth
              hiddenLabel
              type={showPassword ? "text" : "password"}
              id="password"
              name="password"
              value={formik.values.password}
              onChange={(val) => {
                if (val.target.value === " " || val.target.value === ".") {
                } else {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              helperText={
                formik.touched.password && (formik.errors.password as string)
              }
              error={formik.touched.password && Boolean(formik.errors.password)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" className="eye_btn">
                    <IconButton
                      aria-label={
                        showPassword ? "Hide password" : "Show password"
                      }
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div className="control_group d_flex">
            <div className="remember_box">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formik.values.remember}
                    name="remember"
                    onChange={formik.handleChange}
                  />
                }
                name="remember"
                label="Remember me"
              />
            </div>
            <a
              href="javacript:void(0)"
              className="anchor_link"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </a>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary w_100" type="submit">
              Login
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
